function a() {
  this.__data__ = [], this.size = 0;
}
var t = a;
export {
  t as _
};
